export default {
  meta: {
    title: '菜单访问控制'
  }
};
